import { IBaseResponse } from "~/utils/interface/base";
import axiosClient from "./axiosClient";
import { ContentTypeEnum } from "~/utils/enum/common"; 
import { UpsertModuleWatchProgressBody } from "~/utils/interface/module";

const toAbsoluteUrl = (url: string) => {
  if (/^https?:\/\//i.test(url)) return url;
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
};

export const moduleApi = {      
  upsertModuleWatchProgress(moduleId: number, body: UpsertModuleWatchProgressBody) {
    return axiosClient.post<IBaseResponse<any>>(
      `/modules/${moduleId}/progress`,
      body,
      { headers: { 'Content-Type': ContentTypeEnum.JSON } }
    );
  },

  upsertModuleWatchProgressBeacon(moduleId: number, body: UpsertModuleWatchProgressBody) {
    try {
      const url = toAbsoluteUrl(`/modules/${moduleId}/progress`);
      if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
        const blob = new Blob([JSON.stringify(body)], { type: ContentTypeEnum.JSON as string });
        const ok = navigator.sendBeacon(url, blob);
        if (ok) return true;
      } 
      void axiosClient.post(url, body, { headers: { 'Content-Type': ContentTypeEnum.JSON }, timeout: 2000 });
    } catch { 
    }
    return false;
  },
}